// Слияние bodyVox с сервером: урон монотонен (бит 0 не снова 1), полная
// подмена буфера только при респавне — иначе снапшот/интерполяция могли
// кратковременно «вылечить» визуал.

import type { MeshInstance } from "./renderer";
import { BODY_VOX_GRID_BYTES } from "./bodyVox";

/**
 * @param fullReplace — true при респавне: копия `server` целиком (сервер вызвал InitBodyVoxAlive).
 *  Иначе: `inst.bodyVoxAlive &= server` по байтам (клиент накапливает повреждения).
 * @param serverShell — v13: битмаска гладкой оболочки (если не передана — слой не трогаем).
 * @returns true если в этом апдейте сняты биты верхней гладкой оболочки (outer shell).
 */
export function applyServerBodyVox(
  inst: MeshInstance,
  server: Uint8Array,
  fullReplace: boolean,
  serverShell?: Uint8Array,
): boolean {
  if (server.length !== BODY_VOX_GRID_BYTES) return false;

  const coreSrc =
    inst.bodyVoxAlive &&
    server.buffer === inst.bodyVoxAlive.buffer &&
    server.byteOffset === inst.bodyVoxAlive.byteOffset &&
    server.byteLength === inst.bodyVoxAlive.byteLength
      ? new Uint8Array(server)
      : server;

  if (
    fullReplace ||
    !inst.bodyVoxAlive ||
    inst.bodyVoxAlive.length !== BODY_VOX_GRID_BYTES
  ) {
    inst.bodyVoxAlive = new Uint8Array(coreSrc);
    inst.bodyVoxPrevForDebris = null;
    if (fullReplace) inst.bodyVoxShellPrevForDebris = null;
    if (fullReplace) inst.bodyVoxHashInit = false;
  } else {
    const p = inst.bodyVoxAlive;
    for (let i = 0; i < BODY_VOX_GRID_BYTES; i++) {
      p[i] = p[i]! & coreSrc[i]!;
    }
  }

  if (!serverShell || serverShell.length !== BODY_VOX_GRID_BYTES) {
    if (fullReplace) {
      inst.bodyVoxShell = null;
      inst.bodyVoxShellPrevForDebris = null;
    }
    return false;
  }

  const shellSrc =
    inst.bodyVoxShell &&
    serverShell.buffer === inst.bodyVoxShell.buffer &&
    serverShell.byteOffset === inst.bodyVoxShell.byteOffset &&
    serverShell.byteLength === inst.bodyVoxShell.byteLength
      ? new Uint8Array(serverShell)
      : serverShell;

  if (
    fullReplace ||
    !inst.bodyVoxShell ||
    inst.bodyVoxShell.length !== BODY_VOX_GRID_BYTES
  ) {
    inst.bodyVoxShell = new Uint8Array(shellSrc);
    if (!fullReplace) {
      inst.bodyVoxPrevForDebris = null;
    }
    inst.bodyVoxShellPrevForDebris = null;
    if (fullReplace) inst.bodyVoxHashInit = false;
    return false;
  }

  let shellBitsLost = false;
  const s = inst.bodyVoxShell;
  for (let i = 0; i < BODY_VOX_GRID_BYTES; i++) {
    const before = s[i]!;
    const sb = shellSrc[i]!;
    const after = before & sb;
    if ((before & ~after) !== 0) shellBitsLost = true;
    s[i] = after;
  }
  return shellBitsLost;
}
